import api, { unwrap } from './client'
import type { ClaudeUsageSnapshot } from '@/types/models'

export const claudeUsageApi = {
  current(): Promise<ClaudeUsageSnapshot> {
    return unwrap(api.get<{ data: ClaudeUsageSnapshot }>('/claude-usage'))
  },
}
